import axios from "axios";

const URL = "http://ec2-3-83-53-222.compute-1.amazonaws.com/content";

export const getBackgroundAndContextContent = async (prompt) => {
  const response = await axios.post(`${URL}/background_and_context/`, null, {
    params: {
      input_data: prompt,
    },
    maxRedirects: 0,
  });
  return response.data;
};

export const getTeamContent = async (prompt) => {
  const response = await axios.post(`${URL}/people/`, null, {
    params: {
      input_data: prompt,
    },
    maxRedirects: 0,
  });
  return response.data;
};

export const getCaseStudiesFromPrompt = async (prompt) => {
  const response = await axios.post(`${URL}/case_studies/`, null, {
    params: {
      input_data: prompt,
    },
    maxRedirects: 0,
  });
  return response?.data;
};
